// extracted by mini-css-extract-plugin
export default {"footerBg":"Tb-z","footerTopLinks":"Ub-z","footerFeedback":"Vb-z","footerSocial":"Wb-z","footerLegalLinks":"Xb-z","footerIconCards":"Yb-z","footerBotCopy":"Zb-z"};